module.exports = __webpack_public_path__ + "img/left.484db850.png";